/**
 * EmptyState — shown when a section has no data or when filters return no results.
 *
 * Props:
 *   icon     — emoji string (e.g. "🍼")
 *   heading  — short warm heading (e.g. "No feeds logged yet")
 *   message  — one line of encouraging copy
 *   onAdd    — optional callback; if provided renders an action button
 *   addLabel — button label (default: "Add first entry")
 */
export default function EmptyState({ icon, heading, message, onAdd, addLabel = 'Add first entry' }) {
  return (
    <div className="empty-state">
      <div className="empty-state-icon">{icon}</div>
      {heading && <h6 className="empty-state-heading">{heading}</h6>}
      {message && <p>{message}</p>}
      {onAdd && (
        <button className="btn btn-primary btn-sm mt-3 px-4" onClick={onAdd}>
          {addLabel}
        </button>
      )}
    </div>
  );
}
